// extracted by mini-css-extract-plugin
module.exports = {"Main":"index-module--Main--mSgWE"};